import { render, staticRenderFns } from "./TrainRanking.vue?vue&type=template&id=6300e4e6&scoped=true"
import script from "./TrainRanking.vue?vue&type=script&lang=js"
export * from "./TrainRanking.vue?vue&type=script&lang=js"
import style0 from "./TrainRanking.vue?vue&type=style&index=0&id=6300e4e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6300e4e6",
  null
  
)

export default component.exports